import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {initReactI18next} from 'react-i18next';
import esJSON from "./locales/es/virtualWindow.json";
import enJSON from "./locales/en/virtualWindow.json";

i18n
	// load translation using http -> see /public/locales
	// learn more: https://github.com/i18next/i18next-http-backend
	// detect user language
	// learn more: https://github.com/i18next/i18next-browser-languageDetector
	.use(LanguageDetector)
	// pass the i18n instance to react-i18next.
	.use(initReactI18next)
	// init i18next
	// for all options read: https://www.i18next.com/overview/configuration-options
	.init({
		fallbackLng: 'en',
		debug: true,
		backend: {
			loadPath: '/locales/{{lng}}/{{ns}}.json'
		},
		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		},
		ns: [
			'virtualWindow'
		]
	})

i18n.addResourceBundle('en', 'virtualWindow', enJSON);
i18n.addResourceBundle('es', 'virtualWindow', esJSON)


export default i18n;
